import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { RESULTS_SECTION_STRINGS } from '../../constants/appConstants';
import styles from './SearchResultsControls.module.scss';

const STRINGS = RESULTS_SECTION_STRINGS.CONTROLS;

const SORT_OPTIONS = [
  { value: 'default', label: STRINGS.SORT_DEFAULT },
  { value: 'price-asc', label: STRINGS.SORT_PRICE_ASC },
  { value: 'price-desc', label: STRINGS.SORT_PRICE_DESC },
  { value: 'name-asc', label: STRINGS.SORT_NAME_ASC },
];

const SORT_RATING_OPTION = { value: 'rating-desc', label: STRINGS.SORT_RATING_DESC };

const SearchResultsControls = ({ sortBy, viewMode, showRatingSort, onSortChange, onViewChange }) => (
  <div className={styles.controlsBar}>
    <div className={styles.sortWrap}>
      <label>{STRINGS.SORT_LABEL}</label>
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value)}
        className={styles.sortSelect}
      >
        {SORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
        {showRatingSort && (
          <option value={SORT_RATING_OPTION.value}>{SORT_RATING_OPTION.label}</option>
        )}
      </select>
    </div>

    <div className={styles.viewToggle}>
      <button
        className={`${styles.viewBtn2} ${viewMode === 'grid' ? styles.viewActive : ''}`}
        onClick={() => onViewChange('grid')}
        title={STRINGS.VIEW_GRID}
      >
        <LayoutGrid size={16} />
      </button>
      <button
        className={`${styles.viewBtn2} ${viewMode === 'list' ? styles.viewActive : ''}`}
        onClick={() => onViewChange('list')}
        title={STRINGS.VIEW_LIST}
      >
        <List size={16} />
      </button>
    </div>
  </div>
);

export default React.memo(SearchResultsControls);
